import type { TableColumnsType } from 'antd'
import { Table } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { attemptGetAllOrders, Order, OrderPlaylistOrderBy } from '../../utils/redux/ordersSlice'
import { useAppDispatch, useAppSelector } from '../../utils/redux/store'
import useDynamicColumns from '../../utils/hooks/useAllOrdersDynamicColumns'
import { useNavigate } from 'react-router-dom'


const columns: TableColumnsType<Order> = [
  {
    title: 'Business Name',
    dataIndex: 'businessName',
  },
  {
    title: 'Activity Type',
    dataIndex: 'activityType',
  },
  {
    title: 'Address',
    dataIndex: 'address',
  },
  // {
  //   title: '% Males',
  //   dataIndex: 'males',
  // },
  // {
  //   title: '% Females',
  //   dataIndex: 'females',
  // },
  // {
  //   title: '% Age 18-30',
  //   dataIndex: 'age18_30',
  // },
  // {
  //   title: '% Age 31-45',
  //   dataIndex: 'age31_45',
  // },
  // {
  //   title: '% Age 46-60',
  //   dataIndex: 'age46_60',
  // },
  // {
  //   title: 'Vocal-Instrumental Ratio',
  //   dataIndex: 'vocalToInstrumental',
  // },
  // {
  //   title: 'International-Local Ratio',
  //   dataIndex: 'internationalToLocal',
  // },
  {
    title: 'Clarifications',
    dataIndex: 'extraClarifications',
  },
  // {
  //   title: 'Track Examples',
  //   dataIndex: 'linkTracksExamples',
  //   render: (text: string) => text?.split(',').map((link, idx) => (
  //     <div key={idx}><a href={link.trim()} target="_blank" rel="noreferrer">{link.trim()}</a></div>
  //   )),
  // },
  // {
  //   title: 'Styles',
  //   dataIndex: 'styles',
  //   render: (styles: string[]) => styles?.join(', '),
  // },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    render: (value) => value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-',
  }
]

export default function AllOrders() {
  const dispatch = useAppDispatch()
  const { orders } = useAppSelector((state) => state.orders)

  useEffect(() => {
    dispatch(
      attemptGetAllOrders({
        skip: 0,
        limit: 200,
        oderBy: OrderPlaylistOrderBy.BUSINESS_NAME,
      }),
    )
  }, [])


  // const { columns: _columns, checkBoxOptions, displayedColumns, setDisplayedColumns } = useDynamicColumns({ columns, defaultActiveColumns: ['businessName', 'createdAt']})
  
  
  const navigate = useNavigate()

  return (
    <>
      <Table<Order>
        // title={() => (
        //   <Checkbox.Group
        //     value={displayedColumns}
        //     options={checkBoxOptions}
        //     onChange={setDisplayedColumns}
        //   />
        // )}
        // onRow={(order) => console.log('order:', order)}
        onRow={(order, rowIndex) => {
          return {
            onClick: (event) => {
              console.log('order:', order)
              navigate(`/users/orders/manage/${order._id}`)
              // editPlaylistDrawerRef.current?.open(playlist)
            },
          }
        }}
        size={'small'}
        sticky
        columns={columns}
        rowKey={(order) => order._id}
        dataSource={Object.values(orders)}
        // scroll={{ y: '70vh' }}
      />
    </>
  )
}
